module.exports = __webpack_public_path__ + "static/media/55_tn.e85f037d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/55_tn.jpg
// module id = 363
// module chunks = 0